import { useMemo, useState } from 'react';

import { Popover } from 'antd';

import Colon from '@lcsc-ui/components/Colon';

import './style.less';

// 标签文本
const LabelText = ({
  label,
  text,
  textBold,
  isTitle,
  link,
  title,
  underline,
  isMro,
  spm,
  onClick,
  labelClassName,
  showLabelTitle,
  line = 1,
}) => {
  const liCls = useMemo(() => {
    const cls = isTitle ? 'mb-[5px] text-[14px]' : 'mb-[6px] text-[12px]';
    return cls;
  }, [isTitle]);

  const [open, setOpen] = useState(false);

  const useOriginalTitle = useMemo(() => {
    const htmlRegex = /<([a-z][^>\s]*)\b[^>]*>(.*?)<\/\1>|<[^>]+>/i;
    return !htmlRegex.test(title);
  }, [title]);

  const content = useMemo(() => {
    if (useOriginalTitle) {
      return;
    }
    return (
      <div
        className="max-w-[580px] break-all border-[1px] border-solid border-[#3c3c3c] bg-[#fff] p-[2px_8px] text-[12px] text-[#3c3c3c]"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
    );
  }, [title]);

  function openChange(value) {
    if (useOriginalTitle) {
      return;
    }
    setOpen(value);
  }

  return (
    <dl className={`pr-[10px] leading-[18px] ${liCls}${textBold ? ' font-bold' : ''} flex`}>
      {label && (
        <>
          <dt
            className={`line-clamp-1 max-w-[80px] break-all font-normal ${labelClassName || 'text-[#949FAB]'}`}
            title={showLabelTitle ? label : undefined}
          >
            {label}
          </dt>
          <Colon className="text-[#949FAB]" />
        </>
      )}
      <Popover
        placement="bottomLeft"
        overlayClassName="lcsc-popover-wrapper-hide-top-arrow"
        mouseEnterDelay={0.5}
        showArrow={false}
        content={content}
        onOpenChange={openChange}
        open={open}
        zIndex={2}
        align={{
          offset: [20, 8],
        }}
      >
        <dd className={`flex-1 ${isMro && !label ? 'line-clamp-2' : `line-clamp-${line}`}`}>
          {link ? (
            <a data-spm={spm} onClick={onClick} href={link} target="_blank">
              <span
                className={`text-[#333333]${textBold ? ' font-bold' : ''} hover:text-[#27aef2] ${underline ? 'underline' : ''} break-all`}
                dangerouslySetInnerHTML={{ __html: text }}
                title={useOriginalTitle ? title : ''}
                onMouseLeave={() => setOpen(false)}
              ></span>
            </a>
          ) : (
            <span
              className={`text-[#333333]${textBold ? ' font-bold' : ''} select-all break-all`}
              dangerouslySetInnerHTML={{ __html: text }}
              title={useOriginalTitle ? title : ''}
              onMouseLeave={() => setOpen(false)}
            ></span>
          )}
        </dd>
      </Popover>
    </dl>
  );
};

export default LabelText;
